const dateOptions = { day: '2-digit', month: '2-digit', year: 'numeric' };
const parseDate = (value) => {
  const date = value ? new Date(value) : null;
  return date && !Number.isNaN(date.getTime()) ? date : null;
};
const format = (date, options = {}) =>
  new Intl.DateTimeFormat('de-DE', {
    timeZone: 'Europe/Berlin',
    ...options,
  }).format(date);

export function newsDate(value) {
  const date = parseDate(value);
  return date ? format(date, dateOptions) : '';
}

export function eventDetails(item) {
  const start = parseDate(item.start);
  const end = item.open_end ? null : parseDate(item.end);
  const day = (date) => format(date, dateOptions);
  const time = (date) => format(date, { hour: '2-digit', minute: '2-digit' });
  const sameDay = start && end && day(start) === day(end);
  return {
    date: start ? format(start, { ...dateOptions, weekday: 'short' }) : '',
    meta: [
      start &&
        (item.whole_day
          ? 'Ganztägig'
          : `${time(start)}${sameDay ? `–${time(end)}` : ''} Uhr`),
      end &&
        !sameDay &&
        `bis ${day(end)}${item.whole_day ? '' : `, ${time(end)} Uhr`}`,
      item.location,
    ]
      .filter(Boolean)
      .join(' · '),
  };
}
